import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService, IMemberAppConfig } from '@sondermind/configuration';
import { ReferenceDataHttpService, ReferenceDataTypes } from '@sondermind/data-access/reference-data';
import { HttpService } from '@sondermind/http';
import { IAPIListResponse } from '@sondermind/utilities/models-http';

import { IClientTerminationReason } from '../../models/client-termination-reasons.model';

@Injectable({
  providedIn: 'root'
})
export class ClientTerminationReasonsHttpService {
  terminationReasons$ = this.referenceDataHttpService
    .list(ReferenceDataTypes.termination_reasons, { sort: [{ key: 'order_number', asc: true }] })
    .pipe(map((e) => e.data));

  constructor(
    private referenceDataHttpService: ReferenceDataHttpService,
    private httpService: HttpService,
    private configurationService: ConfigurationService<IMemberAppConfig>
  ) {}

  updateClientTerminationReason(
    terminationReason: IClientTerminationReason
  ): Observable<IAPIListResponse<IClientTerminationReason>> {
    return this.httpService
      .post<IAPIListResponse<IClientTerminationReason>>(
      this.indexUrl,
      { patient_termination_reason: terminationReason }
    )
      .pipe(
        this.httpService.handleHttpError()
      );
  }

  private get indexUrl(): string {
    return `${this.configurationService.env.svcBase}/clinical/patient_termination_reasons`;
  }
}
